//#!if mobile === true || harvard === true
const getIsMobilePortraitMode = state => state.mobileScreen.isPortraitMode;
const getMobileScreenWidth = state => state.mobileScreen.screenWidth;
//#!endif

export default {
  //#!if mobile === true || harvard === true
  getIsMobilePortraitMode,
  getMobileScreenWidth
  //#!endif
};
